import React from 'react';
import Link from 'next/link';
import Styles from './styles.js';
const AllInclucive = props => {
  const data = props;
  return (
    <div>
      <div className="w-full">
        <div className="lg:container px-6 lg:px-0 mx-auto    pb-6 bg-white ">
          <div className="grid lg:grid-cols-2 grid-cols-1 lg:gap-x-12 gap-y-12  pt-12    md:pb-5">
            <div className=" md:mt-2    ">{data.img}</div>
            <div className="  ">
              <h1
                className={
                  data.spacing
                    ? ' text-[44px] leading-[55px ] text-[#1b1b1b] font-normal pt-2 xl:pt-12 lg:mt-12'
                    : 'res-fs-size  font-normal pt-2 xl:pt-6 mt-1'
                }
                style={{ fontFamily: 'Fjalla One' }}>
                {data.title}
              </h1>
              {data.description}
              {data.btn == true ? (
                data.href ? (
                  <Link href={data.href}>
                    <button
                      type="button"
                      className="btn  font-semibold text-base rounded-0 mt-4"
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',
                        padding: '15px 32px',
                      }}>
                      {data.btnTitle}
                    </button>
                  </Link>
                ) : (
                  <a href={data.hrefExt}>
                    <button
                      type="button"
                      className="btn  font-semibold text-base rounded-0 mt-4"
                      style={{
                        fontFamily: 'Josefin Sans',
                        color: '#010101',
                        backgroundColor: '#FCBD00',
                        padding: '15px 32px',
                      }}>
                      {data.btnTitle}
                    </button>
                  </a>
                )
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <Styles />
    </div>
  );
};

export default AllInclucive;
